import React, { useState } from 'react';
import { Section } from './ui/Section';
import { GoldButton } from './ui/GoldButton';
import { LegalModal } from './ui/LegalModal';
export function FooterClose() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <footer className="bg-[#1a2332] pb-20" data-id="element-28">
      <Section className="pt-10 md:pt-14" data-id="element-29">
        <div className="text-center space-y-8 max-w-2xl mx-auto" data-id="element-30">
          <p className="text-xl md:text-2xl text-[#f5f0e8] leading-relaxed font-light" data-id="element-31">
            No estás pidiendo demasiado.
            <br data-id="element-32" />
            Estás pidiendo lo básico: descanso.
          </p>

          <p className="text-lg text-[#f5f0e8]/80 leading-relaxed" data-id="element-33">
            Y si tu mente se enciende por la noche, no necesitas una
            personalidad nueva. Necesitas un protocolo que no dependa de tu
            fuerza de voluntad a las 3:00am.
          </p>

          <div className="py-8" data-id="element-34">
            <p className="text-3xl md:text-4xl font-serif text-[#c9a04e]" data-id="element-35">
              Apaga la Cabeza.
            </p>
            <p className="text-xl md:text-2xl font-serif text-[#f5f0e8] mt-2" data-id="element-36">
              Y deja de pelearte con la cama.
            </p>
          </div>

          <div className="pb-12" data-id="element-37">
            <GoldButton href="#oferta" data-id="element-38">Empezar hoy</GoldButton>
          </div>

          <div className="text-[#8a9bb0]/40 text-sm pt-12 border-t border-[#f5f0e8]/5 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-39">
            <span data-id="element-40">© 2026 Apaga la Cabeza</span>

            <div className="flex gap-4 md:gap-6" data-id="element-41">
              <button onClick={() => setActiveModal('privacy')} className="hover:text-[#c9a04e] transition-colors underline decoration-transparent hover:decoration-[#c9a04e] underline-offset-4" data-id="element-42">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="hover:text-[#c9a04e] transition-colors underline decoration-transparent hover:decoration-[#c9a04e] underline-offset-4" data-id="element-43">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </Section>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-44">
        <div className="space-y-4" data-id="element-45">
          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-46">
            1. Responsable del Tratamiento
          </h3>
          <p data-id="element-47">
            El responsable del tratamiento de sus datos personales es el titular
            de "Apaga la Cabeza". Esta política explica cómo tratamos la
            información personal que nos facilita.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-48">
            2. Finalidad del Tratamiento
          </h3>
          <p data-id="element-49">
            Tratamos sus datos para:
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-50">
              <li data-id="element-51">Gestionar la compra y entrega del kit digital.</li>
              <li data-id="element-52">Atender sus consultas o dudas.</li>
              <li data-id="element-53">
                Enviar comunicaciones relacionadas con el producto (si ha dado
                su consentimiento).
              </li>
              <li data-id="element-54">Cumplir con obligaciones legales y fiscales.</li>
            </ul>
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-55">3. Legitimación</h3>
          <p data-id="element-56">
            La base legal para el tratamiento de sus datos es la ejecución del
            contrato de compraventa del producto digital y, en su caso, su
            consentimiento expreso para comunicaciones.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-57">
            4. Destinatarios
          </h3>
          <p data-id="element-58">
            Sus datos no se cederán a terceros salvo obligación legal. No
            obstante, utilizamos proveedores de servicios (plataformas de pago,
            alojamiento web, servicios de email) que actúan como encargados del
            tratamiento bajo estrictas condiciones de confidencialidad.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-59">5. Derechos</h3>
          <p data-id="element-60">
            Puede ejercer sus derechos de acceso, rectificación, supresión,
            limitación, portabilidad y oposición contactando a través de los
            canales habilitados en la plataforma de compra.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-61">6. Cookies</h3>
          <p data-id="element-62">
            Este sitio web puede utilizar cookies técnicas necesarias para el
            funcionamiento de la página y el proceso de compra. No utilizamos
            cookies publicitarias de terceros sin su consentimiento.
          </p>
        </div>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-63">
        <div className="space-y-4" data-id="element-64">
          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-65">1. Objeto</h3>
          <p data-id="element-66">
            Las presentes condiciones regulan la compra del producto digital
            "Apaga la Cabeza" (kit imprimible en PDF).
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-67">
            2. Proceso de Compra y Entrega
          </h3>
          <p data-id="element-68">
            Al realizar el pago, recibirá acceso inmediato o un enlace de
            descarga al correo electrónico proporcionado. Asegúrese de
            introducir sus datos correctamente.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-69">3. Precio</h3>
          <p data-id="element-70">
            El precio del producto es el indicado en la web en el momento de la
            compra (impuestos incluidos si aplican). Nos reservamos el derecho a
            modificar precios, pero se respetará el precio de los pedidos ya
            confirmados.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-71">
            4. Derecho de Desistimiento
          </h3>
          <p data-id="element-72">
            Al tratarse de contenido digital que no se presta en soporte
            material, el derecho de desistimiento de 14 días no es aplicable una
            vez que la ejecución ha comenzado (la descarga o acceso al archivo),
            conforme a la normativa de consumo vigente, dado que el usuario
            consiente la pérdida de este derecho al iniciar la descarga.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-73">
            5. Propiedad Intelectual
          </h3>
          <p data-id="element-74">
            El contenido del kit "Apaga la Cabeza" está protegido por derechos
            de autor. La compra otorga una licencia de uso personal e
            intransferible. Queda prohibida su reproducción, distribución,
            comunicación pública o venta a terceros sin autorización expresa.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-75">
            6. Exención de Responsabilidad
          </h3>
          <p data-id="element-76">
            Este producto es una herramienta de organización y bienestar, no un
            tratamiento médico. No sustituye el consejo, diagnóstico o
            tratamiento de profesionales de la salud. Si tiene problemas de
            sueño crónicos o graves, consulte a un especialista.
          </p>

          <h3 className="text-lg font-serif text-[#c9a04e]" data-id="element-77">
            7. Ley Aplicable
          </h3>
          <p data-id="element-78">
            Estas condiciones se rigen por la ley española. Para cualquier
            controversia que pudiera derivarse de la prestación de los servicios
            objeto de estas Condiciones, las partes se someten a los juzgados y
            tribunales competentes.
          </p>
        </div>
      </LegalModal>
    </footer>;
}